import CategoryIndex from './CategoryIndex';

export default CategoryIndex;
